import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useIdemKey } from './useIdemKey';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useModerateDispute() {
  const queryClient = useQueryClient();
  const { generateKey } = useIdemKey();

  return useMutation({
    mutationFn: async ({ disputeId, decision, percent, newDueAt, notes }) => {
      const token = localStorage.getItem('token');
      const idempotencyKey = await generateKey('moderate', { disputeId, decision, percent, newDueAt });
      
      const { data } = await axios.post(
        `${API_BASE}/api/disputes/${disputeId}/moderate`,
        { decision, percent, newDueAt, notes },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-Idempotency-Key': idempotencyKey,
          },
        }
      );
      return data;
    },
    onSuccess: (data, variables) => {
      // Invalidate all related queries
      queryClient.invalidateQueries({ queryKey: ['admin', 'disputes', 'queue'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'disputes', 'overview'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'disputes', 'sla'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'dispute', variables.disputeId] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'dispute', 'timeline', variables.disputeId] });
    },
  });
}
